import { render, staticRenderFns } from "./RegisterNameAndCPFModalPix.vue?vue&type=template&id=fd81aa52&scoped=true&"
import script from "./RegisterNameAndCPFModalPix.vue?vue&type=script&lang=js&"
export * from "./RegisterNameAndCPFModalPix.vue?vue&type=script&lang=js&"
import style0 from "./RegisterNameAndCPFModalPix.vue?vue&type=style&index=0&id=fd81aa52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd81aa52",
  null
  
)

export default component.exports